module.exports = __webpack_public_path__ + "img/login-demo.425c7f6f.svg";